import { render } from "./SavedReportWorkspace.vue?vue&type=template&id=405ffb3a&scoped=true"
import script from "./SavedReportWorkspace.vue?vue&type=script&lang=js"
export * from "./SavedReportWorkspace.vue?vue&type=script&lang=js"

import "./SavedReportWorkspace.vue?vue&type=style&index=0&id=405ffb3a&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405ffb3a"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QBtn,QBanner,QList,QItem,QItemSection,QItemLabel,QIcon});
